import { render, staticRenderFns } from "./FlightCached.vue?vue&type=template&id=664dfefb&scoped=true"
import script from "./FlightCached.vue?vue&type=script&lang=js"
export * from "./FlightCached.vue?vue&type=script&lang=js"
import style0 from "./FlightCached.vue?vue&type=style&index=0&id=664dfefb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664dfefb",
  null
  
)

export default component.exports